// extracted by mini-css-extract-plugin
module.exports = {"layout":"style_layout__NJn7v","layout-body":"style_layout-body__ckDVa"};